import { render, staticRenderFns } from "./ExamAnswerMultipleChoice.vue?vue&type=template&id=23a33daa&"
import script from "./ExamAnswerMultipleChoice.vue?vue&type=script&lang=js&"
export * from "./ExamAnswerMultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./ExamAnswerMultipleChoice.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports